import { CouverturePatient } from './couverture-patient.interface';
import { MSSClinicalDocumentInfo } from './mss-clinical-document-info.interface';

export interface MSSMessage {
  messageId: number;
  date: Date;
  size: number;
  flags?: Array<MSSEnumFlag>;
  folderId: number;
  origId?: number;
  /** Technical id for certain provider (APICrypt - messageId ;)) */
  technicalId?: string;
  addresses?: Array<MSSAddress>;
  isBodyLarger?: boolean;
  subject: string;        // limit 250
  fragment?: string;
  body?: string;
  attachments?: Array<MSSAttachmentResponse>;
}

export interface MSSMessageToSend {
  messageData: MSSMessageToSendData;
  patientInfo?: MSSMessagePatientInfo;
  clinicalDocumentInfo?: MSSClinicalDocumentInfo;
}

export interface MSSMessageToSendData {
  messageId?: number;
  addresses?: Array<MSSAddress>;
  subject?: string;        // limit 250
  replyType?: MSSEnumReplyType;
  priority?: MSSEnumPriority;
  isHtml?: boolean;
  isAccuse?: boolean;
  messageTransferedId?: number;
  DispositionNotificationTo?: string;
  body?: string;
  attachments?: Array<MSSAttachment>;
}

export interface MSSMessagePatientInfo {
  patientId: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  couverture: CouverturePatient;
  mssAddress?: string;
}

export enum MSSEnumFlag {
  'UNREAD' = 'UNREAD',
  'FLAGGED' = 'FLAGGED',
  'ATTACHMENT' = 'ATTACHMENT',
  'REPLIED' = 'REPLIED',
  'SENT_BY_ME' = 'SENT_BY_ME',
  'DELETED' = 'DELETED',
  'DRAFT' = 'DRAFT',
  'FORWARDED' = 'FORWARDED',
  'URGENT' = 'URGENT',
  'LOW_PRIORITY' = 'LOW_PRIORITY',
  'PRIORITY' = 'PRIORITY'
}

export interface MSSAddress {
  email: string;        // limit 256
  type: MSSEnumTypeMail;
  name?: string;
}

export interface MSSAttachment {
  clinicalDocumentData?: any;
  clinicalDocument?: boolean;
  part?: number;
  contentType: string;        // limit 40
  fileName: string;
  file?: string;
  messageId?: number;
  documentAssocieId?: string;
  typeDocumentAssocie?: string;
}

export interface MSSAttachmentResponse extends MSSAttachment {
  size?: number;
}

export enum MSSEnumTypeMail {
  'FROM' = 'FROM',
  'TO' = 'TO',
  'CC' = 'CC',
  'BCC' = 'BCC'
}

export enum MSSEnumReplyType {
  'REPLIED' = 'REPLIED',
  'FORWARDED' = 'FORWARDED'
}

export enum MSSEnumPriority {
  'NORMAL' = 'NORMAL',
  'HAUTE' = 'HAUTE'
}
